<template>
  <div v-if="Object.keys(dataAllQuoteStatus).length !== 0">
    <div class="card has-border">
      <div class="card-header pt-1 pb-1">
        Quote status
        <b-spinner
          v-if="getDAdminIsAllStatusLoading"
          label="Loading..."
          small
        ></b-spinner>
      </div>
      <div class="card-body">
        <dl class="row mb-0">
          <dt class="col-sm-7 fs-9000 fw-500 mb-0">Total Approvals</dt>
          <dd class="col-sm-5 text-right fs-9000 fw-600 mb-0">
            {{ dataAllQuoteStatus.quote_approvals }}
          </dd>
          <dt class="col-sm-7 fs-9000 fw-500 mb-0">Total Docs to Clients</dt>
          <dd class="col-sm-5 text-right fs-9000 fw-600 mb-0">
            {{ dataAllQuoteStatus.quote_docs_to_clients }}
          </dd>
          <dt class="col-sm-7 fs-9000 fw-500 mb-0">Total Docs to Employers</dt>
          <dd class="col-sm-5 text-right fs-9000 fw-600 mb-0">
            {{ dataAllQuoteStatus.quote_docs_to_employers }}
          </dd>
          <dt class="col-sm-7 fs-9000 fw-500 mb-0">Total Docs to Settlement</dt>
          <dd class="col-sm-5 text-right fs-9000 fw-600 mb-0">
            {{ dataAllQuoteStatus.quote_docs_to_settlement }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'WDDashboardAllQuoteStatus',
  props: ['dataAllQuoteStatus'],
  computed: {
    ...mapGetters(['getDAdminIsAllStatusLoading'])
  }
}
</script>
<style scoped>
.card.has-border {
  border: 1px solid;
}
</style>
